<div class="grid place-items-center">
  <div class="instagram-card py-0 w-full max-w-4xl font-15 hidden">
    <div class="card-body px-0">
      <div class="flex flex-col md:flex-row">
        <!-- Image Section -->
        <div class="w-full">
          
          <!-- CAROUSEL MODE (igcarousel + status OK) -->
          <div
            *ngIf="!isVideo && isCarousel"
            class="relative overflow-hidden"
            (mouseenter)="pauseAutoplay()"
            (mouseleave)="resumeAutoplay()">

            <!-- Sliding track -->
            <div
              class="flex w-full carousel-track"
              [style.transform]="'translateX(-' + currentIndex * 100 + '%)'">
              <div
                *ngFor="let img of carouselImages; let i = index"
                class="w-full flex-shrink-0 relative">
                <img
                  [src]="img"
                  class="w-full h-full object-cover instagram-main-img"
                  alt="Carousel image" />
                
                <!-- Overlay for carousel images -->
                <div *ngIf="switchboardImage == 0" class="absolute z-10 bottom-6 left-1/2 -translate-x-1/2 bg-black/20 max-w-[500px] rounded-lg p-4 text-center">
                  <h3 class="text-[28px] leading-8 text-white mt-5">{{ postTitle }}</h3>
                  <div class="my-4 bg-red-500 h-px opacity-100"></div>
                  <p class="mb-5 font-medium text-white">This is a preview image provided by <em>Publio.ai</em></p>
                </div>
              </div>
            </div>

            <!-- Arrows -->
            <button
              type="button"
              class="manage-post-btn carousel-arrow absolute left-3 top-1/2 -translate-y-1/2"
              (click)="prevSlide()">
              <mat-icon>chevron_left</mat-icon>
            </button>

            <button
              type="button"
              class="manage-post-btn carousel-arrow absolute right-3 top-1/2 -translate-y-1/2"
              (click)="nextSlide()">
              <mat-icon>chevron_right</mat-icon>
            </button>

            <!-- Dots -->
            <div
              class="absolute bottom-3 left-1/2 -translate-x-1/2
                    inline-flex items-center gap-1
                    rounded-full bg-black/40 px-2 py-1">
              <button
                type="button"
                *ngFor="let img of carouselImages; let i = index"
                class="h-1.5 w-1.5 rounded-full"
                [ngClass]="i === currentIndex ? 'bg-white' : 'bg-white/60'"
                (click)="goToSlide(i)">
              </button>
            </div>
          </div>

          <!-- SINGLE IMAGE -->
          <div *ngIf="!isVideo && !isCarousel && switchboardImage == 0"
               class="relative w-full max-w-full overflow-hidden px-4  border-r border-gray-300">
            <img [src]="mainImageUrl"
                 alt=""
                 class="block w-full h-auto max-h-[80vh] object-contain mx-auto" />

            <div class="absolute z-10 bottom-6 left-1/2 -translate-x-1/2 bg-black/20 max-w-[500px] rounded-lg p-4 text-center">
              <h3 class="text-[28px] leading-8 text-white mt-5">{{ postTitle }}</h3>
              <div class="my-4 bg-red-500 h-px opacity-100"></div>
              <p class="mb-5 font-medium text-white">This is a preview image provided by <em>Publio.ai</em></p>
            </div>
          </div>

          <!-- SINGLE IMAGE -->
          <div *ngIf="!isVideo && !isCarousel && switchboardImage == 1"
               class="relative w-full max-w-full overflow-hidden bg-gray-200 border-r border-gray-300">
            <img src="{{mainImageUrl}}" class="block w-full h-auto max-h-[80vh] object-contain mx-auto" alt="">
          </div>

          <!-- OLD STATIC creatomateVideo-->
          <div *ngIf="creatomateVideo == 1">
            <div class="image-container">
              <video controls class="mx-auto">
                <source
                  src="https://f002.backblazeb2.com/file/creatomate-c8xg3hsxdu/b49a312e-df89-484a-8b46-6031d86d898d.mp4"
                  type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          <!-- DYNAMIC VIDEO MODE -->
          <div *ngIf="isVideo">
            <div class="image-container">
              <video controls  [attr.poster]="mainImageUrl" class="mx-auto w-full">
                <source [src]="videoUrl" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          
        </div>
        <!-- Content Section -->
        <div class="w-5/12 py-3 pl-0 md:pl-0 hidden md:block relative">
          <!-- User Info -->
          <div class="px-3">
            <div class="flex items-center mb-3 py-1">
              <img src="{{thumbnailFilePath}}" class="rounded-full me-2 instagram-avatar" />
              <div>
                <p class="mb-0 flex items-center gap-1 bold-600 font-13">
                  {{ siteDomain }} &bull; <span class="blue-link">Follow</span>
                </p>
              </div>
              <div class="ml-auto">
                <img src="assets/icons/dots.png" class="rounded-full mt-2 me-1 dots-icon" />
              </div>
            </div>
          </div>
          <hr class="my-2" />
          <!-- Post Content -->
          <div class="px-3">
            <div class="flex items-start mb-3">
              <img src="{{thumbnailFilePath}}" class="rounded-full me-2 instagram-avatar" />
              <div>
                <p class="mb-0 gap-1 bold-600">
                  {{postFeed}} <br> <small class="text-muted flex items-center"> {{formattedDate}} -
                    &nbsp;<img src="assets/icons/world.png" class="rounded-full world-icon" /></small>
                </p>
                <p class="mt-1 text-sm" [attr.dir]="textDirection">
                  {{postDescription }}
                </p>
              </div>
            </div>
          </div>

          <!-- Comment Placeholder -->
          <div class="p-3">
            <div class="text-center">
              <h4 class="font-bold">No comments yet.</h4>
              <p class="font-15">Start the conversation.</p>
            </div>
          </div>

          <!-- Engagement Buttons -->
        <div class="mt-auto w-full pb-3">

            <hr class="mt-12 mb-4" />

            <div class="grid grid-cols-2 gap-4 px-3">
              <div class="flex items-center mb-3 md:mb-0">
                <img src="assets/icons/heart.png" class="instagram-like-icon me-3" />
                <img src="assets/icons/comment.png" class="instagram-like-icon me-3" />
                <img src="assets/icons/send.png" class="instagram-like-icon" />
              </div>
              <div class="flex justify-end mb-3 md:mb-0">
                <img src="assets/icons/saved.png" class="instagram-like-icon" />
              </div>
            </div>

            <!-- Likes and Time -->
            <div class="mt-2 px-3 ">
              <span class="font-bold"># likes</span><br />
              <small class="text-muted"># hours before</small>
            </div>

            <!-- Comment Input -->
            <div class="grid grid-cols-12 px-3">

              <div class="flex items-center mt-6 gap-2 col-span-9">
                <img src="assets/icons/instagram-comment-avatar.png" class="rounded-full comment-avatar" />
                <div class="text-muted font-13">Add a comment...</div>
              </div> <!-- Emoji Icon -->
              <div class="mt-6 ml-auto col-span-3">
                <img src="assets/icons/smile.png" class="emoji-icon" />
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
